import { call } from 'api'

export const fetch = (successCallback, errorCallback) => call('/notice', { method: 'GET' }, successCallback, errorCallback)



// WEBPACK FOOTER //
// ./src/api/notices.js